__turbopack_context__.v({
  "banner": "GlobalBanner-module__YiKvAG__banner",
});
